
import { Component, Prop, Vue } from "vue-property-decorator";
import type {VideoMediaType} from '../../types/MediaTypes';

@Component({})
export default class GalleryVideoComponent extends Vue {
    @Prop() readonly video!: VideoMediaType

    formatVideoDuration(milliseconds:number) : string {
        // Kind of a hack, but works as long as duration is less than 60 minutes
        return new Date(milliseconds).toISOString().slice(14,19);
    }
}
